/**
 * Returns a promise that resolves after `time` milliseconds
 * @param time Number of millisecond to wait
 */
export function delay(time: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, time));
}

/**
 * Periodically executes `isConditionVerified` method every `cooldown` ms until it resolves with true or the `timeout` is reached
 * @param isConditionVerified The function that evaluates if the exit confidtion is satisfied
 * @param cooldown The time to wait between the executions of `isConditionVerified`
 * @param timeout The total allowed time, if the execution of waitUntil execeed this value, it will automatically return
 */
export async function waitUntil(
  isConditionVerified: () => PromiseLike<boolean> | boolean,
  cooldown = 200,
  timeout = 30000,
): Promise<void> {
  let intervalId: NodeJS.Timeout;
  let timeoutId: NodeJS.Timeout;

  const waitForCondition = new Promise<void>((resolve) => {
    const checkCondition = async () => {
      const result = await isConditionVerified();
      if (result) {
        resolve();
      }
    };
    checkCondition();
    intervalId = setInterval(() => checkCondition(), cooldown);
  });

  const timeoutPromise = new Promise<void>((resolve) => {
    timeoutId = setTimeout(resolve, timeout);
  });

  await Promise.race([waitForCondition, timeoutPromise]);

  clearInterval(intervalId);
  clearTimeout(timeoutId);
}
